import type { ChatUiApprovalBulkResult } from '@voll-intelligence/genui-contract';
import { CardFooter } from '../../../shared/ui/card.js';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import '@voll-intelligence/intelligence-ui-kit/flight-offers.css';
import '../../../shared/ui/flight_ui.css';
import '../../shared/approval.css';

/**
 * Card de resultado da aprovação em lote (`approval_bulk_result`) — display-only,
 * emitido pelo handler determinístico DEPOIS de publicar as decisões. Mostra o
 * resumo parcial (aprovados/falhas/total). Sem interação (UX-05).
 */
export function ApprovalBulkResultCard({
  result,
  note,
}: {
  readonly result: ChatUiApprovalBulkResult;
  readonly note?: string;
}) {
  const { t } = useGenUiI18n();
  const hasFailures = result.failed > 0;
  return (
    <section className="fui" aria-label={t('approval.bulkResultAria')}>
      <div className="fui-card">
        <div className="fui-body">
          <span className={`appr-result ${hasFailures ? 'is-failed' : 'is-approve'}`}>
            {t(result.total === 1 ? 'approval.bulkSummary_one' : 'approval.bulkSummary_other', {
              approved: result.approved,
              total: result.total,
            })}
          </span>
          {hasFailures && (
            <div className="fui-cf-summary">
              <span className="fui-k">{t('approval.failures')}</span>
              <span className="fui-v">{result.failed}</span>
            </div>
          )}
        </div>
        <CardFooter note={note} />
      </div>
    </section>
  );
}
